import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleFill, PiCircleFill } from 'react-icons/pi';
import './YearSelectCard.scss';

interface IYearSelectCardProps {
  year: number;
  isSelected?: boolean;
  onClick?: (year: number) => void;
  disabled?: boolean;
}

const YearSelectCard = ({ year, isSelected, onClick, disabled }: IYearSelectCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames('year-select-card', { isSelected, disabled })}
      onClick={() => !disabled && onClick && onClick(year)}
    >
      <div className="year-select-card-header">{year}</div>
      {isSelected ? <PiCheckCircleFill /> : <PiCircleFill />}
    </div>
  );
};

export default YearSelectCard;
